import type { SVGProps } from 'react';
import { FC } from 'react';
import { SvgIcon } from '../SvgIcon';

/**
 * "Add Section" glyph — the bidirectional arrow icon used on V2's
 * `+ Add Section` button. Uses `currentColor` so it inherits the surrounding
 * button text color.
 *
 * Original artwork is positioned at (146.7, 13) in a larger Sketch canvas, so
 * the viewBox is offset to display it correctly.
 */
export const AddSectionIcon: FC<SVGProps<SVGSVGElement>> = ({ width = 24, height = 18, ...props }) => (
	<SvgIcon viewBox='127 13 24 18' width={width} height={height} fill='currentColor' {...props}>
		<path d='M146.707,20.414 L150.414,16.707 L146.707,13 L145.293,14.414 L146.586,15.707 L144,15.707 C140.095,15.707 139.057,17.196 138.142,18.51 C137.321,19.689 136.611,20.707 133,20.707 L127,20.707 L127,22.707 L133,22.707 C136.611,22.707 137.321,23.725 138.142,24.904 C139.057,26.218 140.095,27.707 144,27.707 L146.586,27.707 L145.293,29 L146.707,30.414 L150.414,26.707 L146.707,23 L145.293,24.414 L146.586,25.707 L144,25.707 C141.139,25.707 140.57,24.891 139.783,23.761 C139.305,23.074 138.767,22.303 137.754,21.707 C138.767,21.111 139.305,20.34 139.783,19.653 C140.57,18.523 141.139,17.707 144,17.707 L146.586,17.707 L145.293,19 L146.707,20.414 Z' />
	</SvgIcon>
);
